import { makeStyles } from '@mui/styles'
const useStyleSecurity = makeStyles(() => ({
  backgroundBox: {
    width: '100%',
    height: '100vh',
    '@media all and (max-width: 900px)': {
      height: '80vh',
      marginTop: 80
    }
  },

  titleStyle: {
    display: 'flex',
    alignItems: ' center',
    color: '#2C3532',
    marginLeft: '5%',
    marginTop: '1.5rem'
  },
  titleTypography: {
    fontSize: '2em',
    letterSpacing: '0.04rem',
    '@media all and (max-width: 600px)': {
      fontSize: '1.5em'
    }
  },
  boxSubTitle: {
    width: '90%',
    display: 'flex',
    alignItems: 'center',
    color: '#4B4952',
    background: '#f9f9f9',
    boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
    borderRadius: 10,
    paddingBottom: 10,
    paddingTop: 10,
    marginLeft: '5%',
    marginTop: '0.5rem',
    '@media all and (max-width: 600px)': {
      fontSize: '0.8em'
    }
  },
  subtitle: {
    fontSize: '0.9rem',
    marginLeft: 8,
    fontWeight: 'bold'
  },
  instructionsBox: {
    display: 'flex',
    alignItems: 'center',
    color: '#2C3532',
    marginLeft: '5%',
    marginTop: '0.7rem'
  },
  helpTypography: {
    fontSize: '1em'
  },
  containerStyle: {
    width: '95%',
    marginLeft: '5%',
    marginTop: '2rem'
  },
  containerStyle2: {
    color: '#2C3532'
  },
  formControl: {
    width: '40%',
    '@media all and (max-width: 900px)': {
      width: '60%'
    }
  }
}))

export default useStyleSecurity
